import { STUDENT_PORTAL_URL } from "./Matcher";

// Where "Free assessment" and "Enrol now" go.
//
// Both land on the same question — new student, or one who already has a
// login — because everything after that point differs. The errand is carried
// in the URL so the answer leads somewhere different: an assessment goes on
// to campus-or-online, an enrolment to the course picker.
//
// These live in the student portal, not here. The portal is where accounts,
// class times and fees already are; a second copy on the marketing site is
// what left an enrolment wizard posting to an IP address that stopped
// resolving years ago.

export const startUrl = (intent) =>
  `${STUDENT_PORTAL_URL}/start?intent=${intent}`;

export const ENROL_URL = startUrl("enrol");
export const FREE_ASSESSMENT_URL = startUrl("assessment");
